import HomeImage from "../image/homeImage-removebg-preview.png";
import { useNavigate } from "react-router-dom";
export const HomeHeader = () => {
  const navigate = useNavigate();

  return (
    <div
      className="relative px-4 pt-16 mx-auto lg:py-32 md:px-8 xl:px-20 sm:max-w-xl md:max-w-full flex items-center justify-center flex-col-reverse md:flex-row md:justify-between"
      style={{ height: "100vh" }}
    >
      <div className="max-w-xl mx-auto lg:max-w-screen-xl w-full md:w-1/2">
        <div className="mb-16 lg:max-w-lg lg:mb-0">
          <div className="max-w-xl mb-6">
            <div>
              <p
                className="inline-block px-3 mb-4 font-semibold tracking-wider uppercase rounded-full py-1  text-lg"
                style={{ backgroundColor: "#f0ad4e" }}
              >
                مخبرش
              </p>
            </div>
            <h2
              className="max-w-lg mb-6 text-3xl font-bold tracking-tight sm:text-4xl sm:leading-none"
              style={{ lineHeight: "1.5" }}
            >
              {" "}
              مخبرش هو موقع من خلاله يمكنك ارسال رسائلك
              <br className="hidden md:block" />
              <span
                className="inline-block text-deep-purple-accent-400 mt-2"
                style={{ lineHeight: "1.5" }}
              >
                الى اي شخص بدون ان يعرف من ارسلها
              </span>
            </h2>
          </div>
          <div className="flex items-center">
            <p
              onClick={() => {
                navigate("/signup");
              }}
              className="inline-flex items-center justify-center h-12 px-6 mr-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-deep-purple-accent-400 hover:bg-deep-purple-accent-700 focus:shadow-outline focus:outline-none"
              style={{ backgroundColor: "#f0ad4e", cursor: "pointer" }}
            >
              انشاء حساب
            </p>
            <p
              onClick={() => {
                navigate("/login");
              }}
              className="rounded-full"
              style={{
                padding: "0.5rem 1rem",
                borderColor: "#f0ad4e !important",
                color: "#f0ad4e !important",
                border: "1px solid #f0ad4e !important",
                cursor: "pointer",
              }}
            >
              لدي حساب
            </p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center h-56 sm:h-96 sm:mb-5 sm:max-w-xl md:max-w-md lg:h-auto lg:max-w-lg md:w-1/2">
        <img
          src={HomeImage}
          className="object-cover h-full max-w-2xl rounded shadow-lg sm:max-w-4xl w-full"
          style={{
            borderRadius: "50%",
            boxShadow:
              "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
          }}
          alt=""
        />
      </div>
    </div>
  );
};
